import { JSX, useEffect, useState } from 'react'
import authService from '../../../services/AuthService'
import { AdminComponentProps } from './AdminComponent.model';

const AdminComponent = ({children}: AdminComponentProps): JSX.Element | null => {

  const [isAdmin, setIsAdmin] = useState<boolean>(false)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    let isActive = true;

    const populateAuthenticationState = async () => {
      const authenticated = await authService.isAuthenticated();
      const user = await authService.getUser();

      if (!isActive) return;

      setIsAdmin(Boolean(authenticated && user && user.isAdmin));
      setIsReady(true);
    };

    const authenticationChanged = () => {
      setIsReady(false);
      setIsAdmin(false);
      void populateAuthenticationState();
    };

    const subscription = authService.subscribe(authenticationChanged);

    void populateAuthenticationState();

    return () => {
      isActive = false;
      authService.unsubscribe(subscription);
    };
  }, [])

  if (!isReady)
    return null;

  if (isAdmin)
    return children();

  return null;
}
export default AdminComponent;
